import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { Post, PostReaction } from "../../../app/app.interfaces";
import { AuthService } from "../../../services/auth.service";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { EventService } from "../../../services/event.service";
import { ApiService } from "../../../services/api.service";
import { ReactionCreate } from "../reaction-create/reaction-create";
import { PostService } from "../../../services/post.service";

@Component({
  selector: 'reaction-card',
  templateUrl: 'reaction-card.html'
})
export class ReactionCard implements  OnInit {
  
  @Input() postReaction: PostReaction;
  @Input() post: Post;
  @Input() parentReaction: PostReaction;
  @Input() userIsPostOwner: boolean = false;
  @Output() onDelete: EventEmitter<PostReaction> = new EventEmitter<PostReaction>();
  @Output() showReactionCreate: EventEmitter<boolean> = new EventEmitter<boolean>();

  edit: boolean = false;
	reportCreate: boolean = false;
  showChildReactionCreate: boolean = false;
  showChildReactions: boolean = true;

  @HostBinding('class.highlight') highlight: boolean = false;
  
  constructor(public authService: AuthService,
              private apiService: ApiService,
              private ionic: IonicHelper,
              public elementRef : ElementRef,
              private eventService: EventService,
              private postService: PostService,
  ) {
  }

  ngOnInit(): void {
		this.eventService.closeReactionCard.subscribe((close) => {
			this.toggleChildReactionCreate(!close);
		});
  }


  reactionChanged(changedReaction){
  	if(changedReaction){
			this.postReaction = changedReaction;
		}
		this.edit = false;
	}
	
	setHighlight(highlight: boolean){
    this.highlight = highlight;
  }
	
  
	deleteReaction(){
    
    if(!this.postReaction.userHasModeratingAccess) {
      throw new Error('User must have moderating access for this');
    }

    this.ionic.confirm('REACTION.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','GLOBAL.DELETE').subscribe((confirmed: boolean) => {
      if(confirmed){
        this.apiService.deleteResource(this.postReaction).then(()=>{
          this.ionic.toast('REACTION.DELETED_TOAST');
          this.onDelete.emit(this.postReaction);          
        }).catch((err) => {
					console.error(err);    	
					this.ionic.alert('GLOBAL.GENERAL_ERROR');
				});
      }
    })    
  }

  
  setPublished(publish: boolean){
    
    if(!this.authService.user.admin) {
      throw new Error('User must be admin for this');
    }
    this.apiService.updateResource(this.postReaction, { published: publish }).then((postReaction: PostReaction) => {
      
      this.postReaction.published = publish;
      this.ionic.toast( publish ? 'REACTION.PUBLISHED_TOAST' : 'REACTION.UNPUBLISHED_TOAST');
    }).catch((err) => {
    	console.error(err);    	
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
		});
     
  }
  
  toggleUpvote(){
    this.postReaction.userHasUpvoted = !(this.postReaction.userHasUpvoted);    
    this.apiService.resourceCustomPut(this.postReaction['@id'], 'vote/toggle').then((postReaction: PostReaction)=> {      
      this.postReaction.upvotesCount = postReaction.upvotesCount;
      this.postReaction.upvotes = postReaction.upvotes;
      // this.postReaction.userHasUpvoted = postReaction.userHasUpvoted;
    }).catch((err) => {
      console.error(err);    	
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
    });
    
  }

  toggleReportCreate(open: boolean = true){
		this.reportCreate = open;
	}
  
	toggleChildReactionCreate(show:boolean = true): void{
  	this.showChildReactionCreate = show;
		this.eventService.toggleTabBar.emit(!show);
		this.showReactionCreate.emit(show);
		// if(this.showChildReactionCreate){
     //  this.headerBarMobileTemplate = 'reaction';
     //  this.headerBarMobileTitle = 'reaction';   
     // 
     //  if(this.ionic.isMobile()){
     //    this.container.scrollToTop(0);
     //  }
		// }
		// else{
     //  this.headerBarMobileTemplate = 'back';
     //  this.headerBarMobileTitle = 'post';
		// 	this.pageTitleService.setPageTitle('post', this.post);
		// }
	}
	
	
  
  removeChildReaction(postReaction: PostReaction){
    this.postReaction.reactions = this.postReaction.reactions.filter(e => e !== postReaction);
  }
  
  childReactionPlaced(newReaction: PostReaction){
  	if(newReaction) {
      this.postReaction.reactions.push(newReaction);
      this.postReaction.reactionsCount++;
		}
		this.toggleChildReactionCreate(false);
  	this.showChildReactions = true;
	}


  unsetAsBest(){
    this.eventService.unsetPostBestReaction.emit({ post: this.post, postReaction: this.postReaction});
  }

  setAsBest(){
    this.eventService.setPostBestReaction.emit({ post: this.post, postReaction: this.postReaction});
  }


}




// WEBPACK FOOTER //
// ./src/partials/reaction/reaction-card/reaction-card.ts